import { FC } from "react"
import type { FieldProps } from "@rjsf/core"
import { JSONSchema7 } from "json-schema"
import { Title } from "dash-styled"
import { DescriptionField } from "resha"

export const SectionField: FC<FieldProps> = ({
    formData,
    registry,
    idSchema,
    onChange,
    errorSchema,
    onBlur,
    onFocus,
    uiSchema,
    required,
    readonly,
    autofocus,
    schema,
    name
}) => {
    const SchemaField = registry.fields.SchemaField

    const handleChange = (e: unknown) => {
        onChange({
            ...formData,
            data: e
        })
    }

    return (
        <div className="w-full my-8">
            <Title variant="heading3" weight="semibold">
                {schema.title}
            </Title>
            <DescriptionField description={schema.description} />
            <SchemaField
                name={name}
                formContext={{}}
                errorSchema={errorSchema.data}
                idPrefix={{}}
                autofocus={autofocus}
                readonly={readonly}
                required={required}
                uiSchema={uiSchema.data}
                idSchema={idSchema.data}
                formData={formData.data}
                onChange={handleChange}
                onBlur={onBlur}
                onFocus={onFocus}
                registry={{
                    ...registry,
                    formContext: {
                        ...registry.formContext,
                        onChange: handleChange
                    }
                }}
                disabled={!formData.editable}
                schema={{
                    ...(schema.properties?.data as JSONSchema7),
                    title: ""
                }}
            />
        </div>
    )
}
